import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormlyModule } from '@ngx-formly/core';
import { AddonsWrapperComponent } from './addons-wrapper.component';
import { MatIconModule } from '@angular/material/icon';
import {
  AvatarModule,
  MatTooltipAddonsDirective,
} from '@lockton-apps/shared/ui/lui';
import { MaterialModule } from '@lockton-apps/material';

@NgModule({
  declarations: [AddonsWrapperComponent],
  imports: [
    CommonModule,
    FormlyModule.forChild({
      wrappers: [
        {
          name: 'addons',
          component: AddonsWrapperComponent,
        },
      ],
    }),
    MatIconModule,
    AvatarModule,
    MaterialModule,
    MatTooltipAddonsDirective,
  ],
})
export class AddonsWrapperModule {}
